import { borderRadius } from "../styles";

export const graphFilterStyle = {
  direction: "row",
  gap: "4",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  backgroundColor: "gray.200",
  padding: "4",
  borderTopRadius: borderRadius,
};
